export const createRouteMessage = (
  msg: string,
  type: 'success' | 'warning' | 'error' | 'info' = 'success',
) => ({
  type: 'ROUTE_MESSAGE',
  message: msg,
  messageType: type,
  at: new Date(),
});
